import styled, { css } from 'styled-components';
import { Swiper as BaseSwiper } from 'swiper/react';

type CustomSwiperProps = {
  offsetSlide?: boolean;
};

const offsetSlideStyles = css`
  width: 80%;
`;

export const Swiper = styled(BaseSwiper)<CustomSwiperProps>`
  .swiper-slide {
    ${(props) => (props.offsetSlide ? offsetSlideStyles : '')};
  }

  .swiper-navigation {
    bottom: 10px;
  }
`;
